import React from 'react';
import { Section } from './ui/Section';
import { Moon, Sun, BookOpen } from 'lucide-react';
export function SolutionSection() {
  return <div className="bg-midnight-800 py-12" data-id="element-135">
      <Section data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-6 tracking-wide" data-id="element-138">
            El mecanismo que cambia el juego: <br data-id="element-139" />
            <span className="text-accent-blue" data-id="element-140">Protocolo 3AM</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-141">
            No es motivación. No es "relájate". No es magia. <br data-id="element-142" />
            Es una secuencia diseñada para reentrenar tu sistema.
          </p>
        </div>

        <div className="space-y-8 relative" data-id="element-143">
          {/* Connecting Line */}
          <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-gradient-to-b from-accent-blue/20 via-accent-blue/50 to-accent-blue/20 hidden md:block" data-id="element-144" />

          {/* Step 1 */}
          <div className="relative md:pl-24" data-id="element-145">
            <div className="hidden md:flex absolute left-0 top-0 w-16 h-16 bg-midnight-800 border border-accent-blue/30 rounded-full items-center justify-center z-10" data-id="element-146">
              <Moon className="text-accent-blue w-6 h-6" data-id="element-147" />
            </div>
            <div className="card-glass p-8 hover:border-accent-blue/30 transition-colors" data-id="element-148">
              <div className="flex items-center gap-4 mb-4 md:hidden" data-id="element-149">
                <Moon className="text-accent-blue w-6 h-6" data-id="element-150" />
                <h3 className="text-xl font-bold text-white" data-id="element-151">Paso 1</h3>
              </div>
              <h3 className="text-2xl font-display font-bold text-white mb-2 tracking-wide" data-id="element-152">
                Preparación 9PM (10 min)
              </h3>
              <p className="text-slate-300" data-id="element-153">
                Cierras el día para que tu mente no use la madrugada como
                oficina. Una técnica simple de descarga mental que "apaga" los
                pendientes antes de tocar la almohada.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative md:pl-24" data-id="element-154">
            <div className="hidden md:flex absolute left-0 top-0 w-16 h-16 bg-midnight-800 border border-accent-blue rounded-full items-center justify-center z-10 shadow-[0_0_20px_rgba(45,125,255,0.3)]" data-id="element-155">
              <BookOpen className="text-accent-blue w-6 h-6" data-id="element-156" />
            </div>
            <div className="card-glass p-8 border-accent-blue/40 relative" data-id="element-157">
              <div className="absolute -top-3 right-8 bg-accent-blue text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-158">
                Rescate
              </div>
              <div className="flex items-center gap-4 mb-4 md:hidden" data-id="element-159">
                <BookOpen className="text-accent-blue w-6 h-6" data-id="element-160" />
                <h3 className="text-xl font-bold text-white" data-id="element-161">Paso 2</h3>
              </div>
              <h3 className="text-2xl font-display font-bold text-white mb-2 tracking-wide" data-id="element-162">
                Tarjeta de Noche (12 min)
              </h3>
              <p className="text-slate-300" data-id="element-163">
                El rescate exacto para cortar la espiral de ansiedad cuando
                abres los ojos. Sin pantallas, sin luz fuerte. Una serie de
                pasos físicos y mentales para bajar la alerta biológica.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative md:pl-24" data-id="element-164">
            <div className="hidden md:flex absolute left-0 top-0 w-16 h-16 bg-midnight-800 border border-accent-blue/30 rounded-full items-center justify-center z-10" data-id="element-165">
              <Sun className="text-accent-blue w-6 h-6" data-id="element-166" />
            </div>
            <div className="card-glass p-8 hover:border-accent-blue/30 transition-colors" data-id="element-167">
              <div className="flex items-center gap-4 mb-4 md:hidden" data-id="element-168">
                <Sun className="text-accent-blue w-6 h-6" data-id="element-169" />
                <h3 className="text-xl font-bold text-white" data-id="element-170">Paso 3</h3>
              </div>
              <h3 className="text-2xl font-display font-bold text-white mb-2 tracking-wide" data-id="element-171">
                Reset de mañana (10–20 min)
              </h3>
              <p className="text-slate-300" data-id="element-172">
                La señal que reprograma tus noches (la parte que casi nadie
                hace). Usamos la luz y la temperatura para decirle a tu reloj
                biológico que "todo está bien".
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center p-6 bg-accent-blue/5 rounded-lg border border-accent-blue/10" data-id="element-173">
          <p className="text-lg font-medium text-accent-blue/80" data-id="element-174">
            Resultado esperado: Primero baja la alarma. Luego mejora el regreso
            al sueño. Luego baja el patrón 3AM.
          </p>
        </div>
      </Section>
    </div>;
}